<div class="page-print a3-portrait">
	@if (isDemo()) {
	<div class="watermark">
		<p>{{ labels().WATERMARK_DEMO }}</p>
	</div>
	}
	<div class="menu-print" style="padding-top: .3cm;">
		<div class="voice-menu" style="padding-left: 25%">
			<div class="row justify-content-center" style="font-size: 15pt;">
				<strong>{{ labels().FITBONE_PREOP_PLAN_GEN_BY }} {{drFullName()}}</strong>
			</div>
			<span><strong>{{ labels().PRT_OR_PLAN_COMPONENT_PATIENT_ID }}</strong>{{currentCase?.patient?.number}}</span>
			<span><strong>{{ labels().PRT_OR_PLAN_COMPONENT_PLAN_ID }}</strong>{{currentCase?.number}}</span>
			<span>
				<strong>{{ labels().PRT_OR_PLAN_COMPONENT_PLAN_SIDE }}</strong>
				{{currentCase?.side | anatomicalSideLabel}}
			</span>
			<span>
				<strong>{{ labels().PRT_OR_PLAN_COMPONENT_PLAN_BONE_TYPE }}</strong>
				{{currentCase?.boneType | boneTypeLabel}}
			</span>
			<span class="d-inline-block position-relative">
				<strong>{{ today | convertDate:false:true }}</strong>
				<span class="date-format date-format-subscript text-dark">{{ dateFormat }}</span>
			</span>
		</div>
		<span class="logo-text">{{ labels().APP_LOGO_TEXT }}</span>
	</div>
	<div class="wrapper-content">

		<ng-content></ng-content>

	</div>
</div>